import { Children, memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function MultiTaxesProvider({ children }) {
  useInjectSaga({ key: 'multiTaxesProvider', saga });
  useInjectReducer({ key: 'multiTaxesProvider', reducer });

  return Children.only(children);
}

MultiTaxesProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

const withConnect = connect();

export { default as useMultiTaxes } from './useMultiTaxes';
export { default as withMultiTaxes } from './withMultiTaxes';
export default compose(withConnect, memo)(MultiTaxesProvider);
